import script from "./DemoQuestionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DemoQuestionCard.vue?vue&type=script&setup=true&lang=js"

import "./DemoQuestionCard.vue?vue&type=style&index=0&id=5284b328&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5284b328"]])

export default __exports__